import { Component, OnInit } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeCs from '@angular/common/locales/cs';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeNl from '@angular/common/locales/nl';
import localePt from '@angular/common/locales/pt';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import { MicrofrontendsService } from '@core/services/microfrontends.service';
import { GtmService } from '@core/services/gtm/gtm.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private AVAILABLE_LANGUAGES = ['cs', 'de', 'en', 'es', 'fr', 'it', 'nl', 'pt'];

  constructor(
    private translate: TranslateService,
    private microfrontendsService: MicrofrontendsService,
    private gtmService: GtmService
  ) {
    // See main.ts
    const debugLang = sessionStorage.getItem('debug_lang');

    if (debugLang !== 'labels') {
      this.translate.setDefaultLang('en');
      registerLocaleData(localeCs, 'cs');
      registerLocaleData(localeDe, 'de');
      registerLocaleData(localeEn, 'en');
      registerLocaleData(localeEs, 'es');
      registerLocaleData(localeFr, 'fr');
      registerLocaleData(localeIt, 'it');
      registerLocaleData(localeNl, 'nl');
      registerLocaleData(localePt, 'pt');

      let browserLang = debugLang || navigator.language || 'en';
      browserLang = browserLang.substr(0, 2);
      if (this.AVAILABLE_LANGUAGES.includes(browserLang)) {
        this.translate.use(browserLang);
      } else {
        this.translate.use('en');
      }
    }
  }

  public ngOnInit(): void {
    if (environment.gtm.enabled) {
      this.gtmService.activeGTagManager();
    }
    this.microfrontendsService.bootstrap();
  }
}
